import { CheckCircleOutlined, MailOutlined } from '@ant-design/icons';
import { Button, Col, Result, Row, Space, Typography } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';

import { showErrorMessage } from '@/utils';
import { useCompleteRegistration } from '@/web-api/public';

import { WebLayout } from './WebLayout';

const { Title, Paragraph } = Typography;

export const WebVerifyEmail = () => {
  const { t } = useTranslation();
  const { token } = useParams();
  const {
    mutate: completeRegistration,
    isPending,
    isError,
    isSuccess,
    error,
  } = useCompleteRegistration();
  const [hasAttempted, setHasAttempted] = useState(false);

  const handleConfirmEmail = () => {
    if (token && !hasAttempted) {
      setHasAttempted(true);
      completeRegistration({ token });
    }
  };

  // Success state
  if (isSuccess) {
    return (
      <WebLayout isLoading={false}>
        <Result
          icon={<CheckCircleOutlined style={{ color: '#52c41a' }} />}
          title={t('forms:emailVerificationSuccessTitle')}
          subTitle={t('forms:emailVerificationSuccessDescription')}
          extra={
            <Link to='/web/request'>
              <Button type='primary' size='large'>
                {t('forms:emailVerificationContinueButton')}
              </Button>
            </Link>
          }
        />
      </WebLayout>
    );
  }

  // Error state
  if (isError) {
    return (
      <WebLayout isLoading={false}>
        <Row justify='center' align='middle' style={{ height: '100%', textAlign: 'center' }}>
          <Col span={24}>
            <Title level={1}>{t(showErrorMessage((error as any)?.code || 'UNKNOWN_ERROR'))}</Title>
          </Col>
        </Row>
      </WebLayout>
    );
  }

  // Default: Confirmation screen
  return (
    <WebLayout isLoading={isPending}>
      <Row justify='center' align='middle' style={{ minHeight: 400 }}>
        <Col xs={24} md={20} lg={16}>
          <Space orientation='vertical' size='large' style={{ width: '100%', textAlign: 'center' }}>
            <MailOutlined style={{ fontSize: 64, color: '#1890ff' }} />
            <Title level={2}>{t('forms:emailVerificationTitle')}</Title>
            <Paragraph style={{ fontSize: 16 }}>
              {t('forms:emailVerificationDescription')}
            </Paragraph>
            <Button type='primary' size='large' onClick={handleConfirmEmail} loading={isPending}>
              {t('forms:emailVerificationConfirmButton')}
            </Button>
          </Space>
        </Col>
      </Row>
    </WebLayout>
  );
};
